export default __webpack_public_path__ + "static/media/alt-text-add.66278cdd.png";